import { render, staticRenderFns } from "./GeneralConsentDetail.vue?vue&type=template&id=25b78510&scoped=true&"
import script from "./GeneralConsentDetail.vue?vue&type=script&lang=js&"
export * from "./GeneralConsentDetail.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConsentDetail.vue?vue&type=style&index=0&id=25b78510&prod&lang=css&"
import style1 from "./GeneralConsentDetail.vue?vue&type=style&index=1&id=25b78510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b78510",
  null
  
)

export default component.exports